import { render } from "./MergeTabs.vue?vue&type=template&id=72c9bc82"
import script from "./MergeTabs.vue?vue&type=script&lang=js"
export * from "./MergeTabs.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__